import { tns } from 'tiny-slider';
import 'npm:tiny-slider/dist/tiny-slider.css'

export const caseStudiesSlider = (slider) => {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    const tnsSlider = tns({
      container: slider,
      items: 1,
      mode: "gallery",
      speed: "600",
      controls: true,
      controlsPosition: 'top',
      controlsText: ['', `<svg width="112" height="112" viewBox="0 0 112 112" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group 16675">
      <circle id="Ellipse 271" opacity="0.5" cx="56" cy="56" r="51" transform="rotate(-90 56 56)" fill="white" stroke="white" stroke-opacity="0.4" stroke-width="10"/>
      <g id="Group 16668">
      <path id="Vector 123" d="M36.1113 56L75.778 56" stroke="#181A20" stroke-width="5.66667"/>
      <path id="Vector 124" d="M58.7773 78.6665L75.7773 56.0754L58.7773 35.2221" stroke="#181A20" stroke-width="5.66667"/>
      </g>
      </g>
      </svg>`],
      nav: true,
      navPosition: "top",
      swipeAngle: 45,
      // mouseDrag: true,
    });
  }
}